<template>
    <footer>
        <div class="actions">
            <TextButton @click="redirectPrivacy">Privacy</TextButton>
            <TextButton @click="redirectTerms">Terms</TextButton>
            <TextButton @click="redirectLogin">Carrier Login</TextButton>
        </div>
        <div class="copyright">
            {{ date }} Dremca, LLC. All rights reserved.
        </div>
    </footer>
</template>
<script>
import { TextButton } from "../style";
export default {
  components: {
    TextButton
  },
  computed: {
    date() {
      let date = new Date();
      return date.getFullYear();
    }
  },
  methods: {
    redirectPrivacy() {
      this.$router.push("/privacy").catch(() => {});
    },
    redirectTerms() {
      this.$router.push("/terms").catch(() => {});
    },
    redirectLogin() {
      this.$router.push("/login").catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/style/_variables.scss";
footer {
    background-color: $background-gray;
    display: flex;
    align-items: center;
    width: 100%;
    transform: translateY(0px);
    transition: $transition-simple-fast;
    z-index: 500;
    box-shadow: none;
    transition-property: transform, box-shadow;
    height: 3.875rem;
    padding: 0 $padding-lg;
    align-content: space-between;
    justify-content: space-between;
    flex-wrap: wrap;
    @include breakpoint(mobile-hd-width) {
        padding: 0 $padding-xxl;
        flex-wrap: nowrap;
    }
    button {
        font-weight: 400;
        font-size: $font-size-sm;
        letter-spacing: normal;
        margin-right: $padding-lg;
        &:last-child {
            margin-right: 0;
        }
        &:hover {
            background-color: $white;
            transition: $transition-simple-fast;
        }
    }
}
.actions {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    @include breakpoint(mobile-hd-width) {
        justify-content: flex-start;
    }
    a {
        cursor: pointer;
        color: $blue-navy;
        text-decoration: none;
        padding: 0 $padding-lg;
    }
}
.copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    @include breakpoint(mobile-hd-width) {
        justify-content: flex-end;
    }
}
</style>
